import 'css-chunksrc/client/pages/zonesPage/zonesPage/addZoneButton/styles.scss';export default {
  "addZoneButton": "_addZoneButton_1hpe1_1",
  "icon": "_icon_1hpe1_21",
  "iconBox": "_iconBox_1hpe1_29"
};